import React, { Component } from 'react'
import {connect} from "react-redux"
import {reduxForm, change} from 'redux-form';
import styles from './clientProfileForm.scss'
import i18n from 'lib/i18n'
import {generateClientDicts} from 'lib/helpers'
import ClientProfileFormResults from './clientProfileFormResults'
import Modal from 'react-modal'
import uuidv4 from 'uuid/v4'
import nesProp from 'nested-property'
import {isAnEmail} from 'lib/validator'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'visible',
        padding: '0em',
    },
}

/**
 * Import actions to help the state control
 */
import {setOpened, setClientSubModule, setB2bCompanyOpened, setB2bCompanySubModule, cleanClientProfileForm,
    setProfileFormCheckbox, cleanProfileFormCheckbox, updateClientProfile, createClientProfile,
    fetchExistingClients, fetchExistingClient, changeListDefaultError, clientProfileFormSentToFalse,
    fetchClientOptionsDict, reportError} from 'state/actions'

/**
 * Components to implement layout
 */
import KeyValue from '../KeyValue'
import Input from '../input'
import { SearchableDynamicListSelectWrapper, SearchableSelectWrapper } from '../../components/shared/select/SelectWrap'
import { DatePicker } from 'components/shared/datePicker'
import EmailListSelect from '../emailListSelect'
import LicensesListSelect from '../licensesListSelect'
import IbansListSelect from '../ibansListSelect'
import PhoneListSelect from '../phoneListSelect'
import RelationListSelect from '../relationListSelect'
import ClientAddressList from '../clientAddressList'
//import BirthPlaceAddressList from '../birthPlaceAddressList'
/**
 * Helper functions to handle data
 */
import {trimObject, hasContent} from 'lib/helpers'
import underscore from 'underscore'
import moment from 'moment'

// Set the translation category
const _ = i18n('clients')
const lodash = lodash;

const generateUUIdForLists = (listForUuid) => {
    if(listForUuid && listForUuid.length && listForUuid.length > 0)
    {
        listForUuid.map((entityValue, entityIndex) =>
        {
            listForUuid[entityIndex]['uniqueId'] = uuidv4()
        })
    }

    return listForUuid
}

/**
 * Generate field implements a field generator wrapper just to add field error
 *
 * @param React Component
 * @param React field data
 *
 * @return HTML Component
 */
const generateField = (component, field ) => {
    return(
        <div>
            {component}
            {field.error && field.touched && <div className = { styles.error }> {field.error} </div> }
        </div>
    )
}

const normalizeData = ( clientData, appLanguage, clientOptionsDict ) => {
    // Normalize person type
    if(clientData && clientData.main.clientType && clientData.main.clientType != undefined)
    {
        clientOptionsDict.personType.map((item) => {
            if(clientData.main.clientType == item.label)
            {
                clientData.main.clientType = item.value
            }
        })
    }

    // get the client data legalForm value. Attention, sometimes that has no exact match, must be compared lowercased
    let clientLegalForm = nesProp.get(clientData, "main.legalForm")
    let clientLegalFormId = nesProp.get(clientData, "main.legalFormId")

    if (clientLegalForm && clientOptionsDict.legalForm) {
        clientOptionsDict.legalForm.map((item) => {
            if (String(clientLegalForm).toUpperCase() == String(item.label).toUpperCase()) {
                clientData.main.legalForm = item.label
                clientData.main.legalFormId = item.value
            }
        })
    }


    // Normalize gender
    if(clientData && clientData.detail.gender && clientData.detail.gender != undefined)
    {
        clientOptionsDict.gender.map((item) => {
            if(clientData.detail.gender == item.label.substring(0,1))
            {
                clientData.detail.gender = item.value
            }
        })
    }

    // Normalize nationality
    if(clientData && clientData.detail.nationality && clientData.detail.nationality != undefined)
    {
        clientOptionsDict.nationality.map((item) => {
            if(clientData.detail.nationality == item.label)
            {
                clientData.detail.nationality = item.value
            }
        })
    }

    // Normalize title
    if(clientData && clientData.detail.title && clientData.detail.title != undefined)
    {
        clientOptionsDict.title.map((item) => {
            if(clientData.detail.title == item.label)
            {
                clientData.detail.title = item.value
            }
        })
    }

    // Normalize birthCountry
    if(clientData && clientData.detail.birthCountry && clientData.detail.birthCountry != undefined )
    {
        clientOptionsDict.birthCountry.map(item => {
            if(clientData.detail.birthCountry == item.label)
            {
                clientData.detail.birthCountry = item.value
            }
        })
    }

    // Normalize maritalStatus
    if(clientData && clientData.detail.maritalStatus && clientData.detail.maritalStatus != undefined )
    {
        clientOptionsDict.maritalStatus.map(item => {
            if(clientData.detail.maritalStatus == item.label)
            {
                clientData.detail.maritalStatus = item.value
            }
        })
    }

    // Normalize ppp

    if(clientData && clientData.detail.ppp && clientData.detail.ppp != undefined )
    {
        clientOptionsDict.ppp.map(item => {
            if(clientData.detail.ppp == item.label)
            {
                clientData.detail.ppp = item.value
            }
        })
    }

    // Normalize profession
    if(clientData && clientData.detail.profession && clientData.detail.profession != undefined )
    {
        clientOptionsDict.profession.map(item => {
            if(clientData.detail.profession == item.label)
            {
                clientData.detail.profession = item.value
            }
        })
    }

    // Normalize activSector
    if(clientData && clientData.detail.activSector && clientData.detail.activSector != undefined )
    {
        clientOptionsDict.activSector.map(item => {
            if(clientData.detail.activSector == item.label)
            {
                clientData.detail.activSector = item.value
            }
        })
    }

    // Normalize socialStatus
    if(clientData && clientData.detail.socialStatus && clientData.detail.socialStatus != undefined )
    {
        clientOptionsDict.socialStatus.map(item => {
            if(clientData.detail.socialStatus == item.label)
            {
                clientData.detail.socialStatus = item.value
            }
        })
    }

    // Normalize taxStatus
    if(clientData && clientData.detail.taxStatus && clientData.detail.taxStatus != undefined )
    {
        clientOptionsDict.taxStatus.map(item => {
            if(clientData.detail.taxStatus == item.label)
            {
                  clientData.detail.taxStatus = item.value
            }
        })
    }

    // Normalize language
    if(clientData && clientData.detail.language && clientData.detail.language != undefined)
    {
        clientOptionsDict.language.map((item) => {
            if(clientData.detail.language == item.label)
            {
                clientData.detail.language = item.value
            }
        })
    }

    // Normalize email default
    if (clientData && clientData.detail && clientData.detail.emails) {
        clientData.detail.emails = clientData.detail.emails.map((item) => {

            if(item != undefined)
            {
                let emailIsDefault = item.default
                if(!underscore.isBoolean(emailIsDefault))

                {
                    emailIsDefault = (item.default === "true" || item.default == true) ? true : false
                }

                const itemFormated = {
                    default: emailIsDefault,
                    email: item.email
                }

                return itemFormated
            }
            else
            {
                return item
            }
        })
    }

    // normalize phone numbers default && mobile
    if(clientData && clientData.detail && clientData.detail.phoneNumbers) {
        clientData.detail.phoneNumbers = clientData.detail.phoneNumbers.map((item) => {
            const itemFormated = {
                default: (item.default === "true" || item.default === true) ? true : false,
                number: item.number,
                mobile: (item.mobile === "true" || item.mobile === true) ? true : false
            }

            return itemFormated
        })
    }

    // normalize main address
    if(clientData && clientData.main && clientData.main.mainAddress)
    {
        clientData.main.mainAddress.zipCity = `${clientData.main.mainAddress.postalCode}_${clientData.main.mainAddress.locality}`

        if(clientData.main.mainAddress.country != undefined)
        {
            clientOptionsDict.country.map((index) => {
                if(clientData.main.mainAddress.country == index.label)
                {
                    clientData.main.mainAddress.country = index.value
                }
            })

            if(typeof clientData.main.mainAddress.country == 'string')
            {
                clientOptionsDict.globalCountry.map((index) => {
                    if(index.label['en'] == clientData.main.mainAddress.country)
                    {
                        clientData.main.mainAddress.country = index.value
                    }

                    else if(index.label['fr'] == clientData.main.mainAddress.country)
                    {
                        clientData.main.mainAddress.country = index.value
                    }
                    else if(index.label['nl'] == clientData.main.mainAddress.country)
                    {
                        clientData.main.mainAddress.country = index.value
                    }
                })
            }
        }
    }

    // normalize correspondance address
    if(clientData && clientData.detail && clientData.detail.correspondanceAddress)
    {
        clientData.detail.correspondanceAddress.zipCity = `${clientData.detail.correspondanceAddress.postalCode}_${clientData.detail.correspondanceAddress.locality}`

        if(clientData.detail.correspondanceAddress.country != undefined)
        {
            clientOptionsDict.country.map((index) => {
                if(clientData.detail.correspondanceAddress.country == index.label)
                {
                    clientData.detail.correspondanceAddress.country = index.value
                }
            })

            if(typeof clientData.detail.correspondanceAddress.country == 'string')
            {
                clientOptionsDict.globalCountry.map((index) => {
                    if(index.label['en'] == clientData.detail.correspondanceAddress.country)
                    {
                        clientData.detail.correspondanceAddress.country = index.value
                    }

                    else if(index.label['fr'] == clientData.detail.correspondanceAddress.country)
                    {
                        clientData.detail.correspondanceAddress.country = index.value
                    }
                    else if(index.label['nl'] == clientData.detail.correspondanceAddress.country)
                    {
                        clientData.detail.correspondanceAddress.country = index.value
                    }
                })
            }
        }
    }

    // normalize relations data
    if(clientData && clientData.detail && clientData.detail.contacts)
    {
        clientData.detail.contacts = clientData.detail.contacts.map((item) => {
            let itemFormated = {
                contactName: item.contactName,
                contactNumber: item.contactNumber,
                contactdateOfBirth: item.contactdateOfBirth,
                contactgender: item.contactgender,
                contactType: item.contactType,
            }

            clientOptionsDict.gender.map((index3) => {
                if(item.contactgender == index3.label.substring(0,1) )
                {
                    itemFormated['contactgender'] = index3.value
                }
            })

            clientOptionsDict.relationType.map((index2) => {
                if(itemFormated.contactType == index2.label )
                {
                    itemFormated['contactType'] = index2.value
                }
            })


            itemFormated['contactFirstName'] = item.contactFirstName
            itemFormated['contactLastName'] = item.contactName


            return itemFormated
        })
    }

    return clientData
}

/**
 * Implement validate function to handle the form inputs
 */
const validate = values => {
    let errors
    errors = {
        detail: {
            emails: [],
            licences: [],
            phoneNumbers: [],
            accountNumbers: [],
            contacts: [],
            correspondanceAddress: {}
        },
        main: {
            mainAddress: {}
        }
    }

    // Set the validation type
    let validationType = (Number(values.main.clientType) == 1) ? 'pr' : 'cp'

    /**
     * Custom validations for person type
     */
    if(validationType == 'pr')
    {
        if(values.main.lastName == '' || values.main.lastName == undefined)
        {
            errors.main.lastName = _('requiredField')
        }

        if(values.main.lastName != undefined && values.main.lastName.length > 50)
        {
            errors.main.lastName = _('maxLength50')
        }

        if(values.main.firstName != undefined && values.main.firstName.length > 50)
        {
            errors.main.firstName = _('maxLength50')
        }

        if(values.main.firstName == '' || values.main.firstName == undefined)
        {
            errors.main.firstName = _('requiredField')
        }

        if(values.detail.title == '' || values.detail.title == undefined)
        {
            errors.detail.title = _('requiredField')
        }

        if(values.detail.language == '' || values.detail.language == undefined)
        {
            errors.detail.language = _('requiredField')
        }

        if(values.detail.nationality == '' || values.detail.nationality == undefined)
        {
            errors.detail.nationality = _('requiredField')
        }

        if(values.detail.gender == '' || values.detail.gender == undefined)
        {
            errors.detail.gender = _('requiredField')
        }

        if(values.detail.birthCountry && values.detail.birthCountry === '1' ){
            if(values.detail.birthPostalCode == '' || values.detail.birthPostalCode == undefined)
            {
                errors.detail.birthPostalCode = _('requiredField')
            }

            if(values.detail.birthLocality == '' || values.detail.birthLocality == undefined)
            {
                errors.detail.birthLocality = _('requiredField')
            }
        }
    }

    if(validationType == 'cp')
    {
        if(values.main.lastName == '' || values.main.lastName == undefined)
        {
            errors.main.lastName = _('requiredField')
        }

        if(values.main.legalForm == '' || values.main.legalForm == undefined)
        {
            errors.main.legalForm = _('requiredField')
        }

        if(values.detail.language == '' || values.detail.language == undefined)
        {
            errors.detail.language = _('requiredField')
        }

    }

    if(values.main.mainAddress.country == '' || values.main.mainAddress == undefined)
    {
        errors.main.mainAddress.country = _('requiredField')
    }

    if(values.main.mainAddress.street == '' || values.main.mainAddress.street == undefined)
    {
        errors.main.mainAddress.street = _('requiredField')
    }

    /** REMOVED AS REQUESTED BY WILLEMOT
    if(values.main.mainAddress.street != undefined && values.main.mainAddress.street.length > 50)
    {
        errors.main.mainAddress.street = _('maxLength50')
    }*/

    if(values.main.mainAddress.number == '' || values.main.mainAddress.number == undefined)
    {
        errors.main.mainAddress.number = _('requiredField')
    }
    if(values.main.mainAddress.number != undefined && values.main.mainAddress.number.length > 10)
    {
        errors.main.mainAddress.number = _('maxLength10')
    }

    if(values.main.mainAddress.extension != undefined && values.main.mainAddress.extension.length > 10)
    {
        errors.main.mainAddress.extension = _('maxLength10')
    }

    if(values.main.mainAddress.country == 1)
    {
        if(values.main.mainAddress.zipCity == '' || values.main.mainAddress.zipCity == undefined)
        {
            errors.main.mainAddress.zipCity = _('requiredField')
        }
    }
    else
    {
        if(values.main.mainAddress.postalCode == '' || values.main.mainAddress.postalCode == undefined)
        {
            errors.main.mainAddress.postalCode = _('requiredField')
        }

        if(values.main.mainAddress.locality == '' || values.main.mainAddress.locality == undefined)
        {
            errors.main.mainAddress.locality = _('requiredField')
        }
    }

    if(values.main.companyRegistrationNumber != undefined && values.main.companyRegistrationNumber.length > 20)
    {
        errors.main.companyRegistrationNumber = _('maxLength10')
    }

    /**
     * Update correspondanceAddress validation based on Brecht request
     * Now validate all fields if one of the data is not empty
     */
    if(values.detail.correspondanceAddress != undefined)
    {
        let emptyFields = true

        // Check if there is any populated field
        Object.keys(values.detail.correspondanceAddress).forEach((key) => {
          let correspondanceField = values.detail.correspondanceAddress[key]

          if(key == 'zipCity')
          {
              if(Number(values.detail.correspondanceAddress.country) == 1 )
              {
                if(correspondanceField != "" && correspondanceField != undefined && correspondanceField != "_")
                {
                    emptyFields = false
                }
              }
          }
          else
          {
            if(correspondanceField != "" && correspondanceField != undefined)
            {
              emptyFields = false
            }
          }
        })


        // Validate every required field if one field is empty
        if(emptyFields == false)
        {
            if(values.detail.correspondanceAddress.country == '' || values.detail.correspondanceAddress.country == undefined)
            {
                errors.detail.correspondanceAddress.country = _('requiredField')
            }

            if(values.detail.correspondanceAddress.street == '' || values.detail.correspondanceAddress.street == undefined)
            {
                errors.detail.correspondanceAddress.street = _('requiredField')
            }

            if(values.detail.correspondanceAddress.number == '' || values.detail.correspondanceAddress.number == undefined)
            {
                errors.detail.correspondanceAddress.number = _('requiredField')
            }
            if(values.detail.correspondanceAddress.number != undefined && values.detail.correspondanceAddress.number.length > 10)
            {
                errors.detail.correspondanceAddress.number = _('maxLength10')
            }

            if(values.detail.correspondanceAddress.extension != undefined && values.detail.correspondanceAddress.extension.length > 10)
            {
                errors.detail.correspondanceAddress.extension = _('maxLength10')
            }

            if(values.detail.correspondanceAddress.country == 1)
            {
                if(values.detail.correspondanceAddress.zipCity == '' || values.detail.correspondanceAddress.zipCity == undefined || values.detail.correspondanceAddress.zipCity == "_")
                {
                    errors.detail.correspondanceAddress.zipCity = _('requiredField')
                }
            }
            else
            {
                if(values.detail.correspondanceAddress.postalCode == '' || values.detail.correspondanceAddress.postalCode == undefined)
                {
                    errors.detail.correspondanceAddress.postalCode = _('requiredField')
                }

                if(values.detail.correspondanceAddress.locality == '' || values.detail.correspondanceAddress.locality == undefined)
                {
                    errors.detail.correspondanceAddress.locality = _('requiredField')
                }
            }
        }
    }

    // Validate companyRegistrationNumber as Brecht requested V3
    if(values.main.companyRegistrationNumber && values.main.companyRegistrationNumber != undefined && values.main.companyRegistrationNumber != "")
    {
        let invalidCRN = true

        /**
         * Check regex for companyRegistrationNumber
         * Test for: (BE) + (4 numbers) . ( 3 numbers) . ( 3 numbers)
         * Regex code ^(BE)+(\d{4}).(\d{3}).(\d{3})$
         */
        if(/^(BE)+(\d{4}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        /**
         * Check regex for companyRegistrationNumber
         * Test for: (4 numbers) . ( 3 numbers) . ( 3 numbers)
         * Regex code ^(\d{4}).(\d{3}).(\d{3})$
         */
        if(/^(\d{4}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        /**
         * Check regex for companyRegistrationNumber
         * Test for: (3 numbers) . ( 3 numbers) . ( 3 numbers)
         * Regex code ^(\d{3}).(\d{3}).(\d{3})$
         */
        if(/^(\d{3}).(\d{3}).(\d{3})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        /**
         * Check regex for companyRegistrationNumber
         * Test for: (BE) + ( 10 numbers)
         * Regex code ^(BE)+(\d{10})$
         */
        if(/^(BE)+(\d{10})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        /**
         * Check regex for companyRegistrationNumber
         * Test for: ( 10 numbers)
         * Regex code ^(\d{10})$
         */
        if(/^(\d{10})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        /**
         * Check regex for companyRegistrationNumber
         * Test for: ( 10 numbers)
         * Regex code ^(\d{10})$
         */
        if(/^(\d{9})$/i.test(values.main.companyRegistrationNumber))
        {
          invalidCRN = false
        }

        if(invalidCRN == true)
        {
          errors.main.companyRegistrationNumber = _('invalidCompanyRegistrationNumber')
        }

    }

    /**
     * Validate email address data
     */
    if(values.detail.emails.length > 0)
    {
        values.detail.emails.map((key, index) =>
        {
            //here
            if (!isAnEmail(key.email))
            {
                if(errors.detail.emails[index] == undefined)
                {
                    errors.detail.emails[index] = {
                        email: _('invalidEmail')
                    }
                }
                else
                {
                    errors.detail.emails[index]['email'] = _('invalidEmail')
                }
            }

            if(key.email.length > 200)
            {
                if(errors.detail.emails[index] == undefined)
                {
                    errors.detail.emails[index] = {
                        email: _('maxLength200')
                    }
                }
                else
                {
                    errors.detail.emails[index]['email'] = _('maxLength200')
                }
            }
        })
    }

    /**
     * Validate phone numbers data
     */
    if(values.detail.phoneNumbers.length > 0)
    {
        values.detail.phoneNumbers.map((key, index) =>
        {
            if(key.number == undefined || key.number == '')
            {
                if(errors.detail.phoneNumbers[index] == undefined)
                {
                    errors.detail.phoneNumbers[index] = {
                        number: _('requiredField')
                    }
                }
                else
                {
                    errors.detail.phoneNumbers[index]['number'] = _('requiredField')
                }
            }

            if(key.number != undefined && key.number.length > 20)
            {
                if(errors.detail.phoneNumbers[index] == undefined)
                {
                    errors.detail.phoneNumbers[index] = {
                        number: _('maxLength20')
                    }
                }
                else
                {
                    errors.detail.phoneNumbers[index]['number'] = _('maxLength20')
                }
            }

            /**
             * Add validation for phone numbers if the input value is just numeric
             */
            if(key.number != undefined && key.number.length > 0)
            {
                if(!/^\d+$/i.test(key.number))
                {
                    if(errors.detail.phoneNumbers[index] == undefined)
                    {
                        errors.detail.phoneNumbers[index] = {
                            number: _('justNumbers')
                        }
                    }
                    else
                    {
                        errors.detail.phoneNumbers[index]['number'] = _('justNumbers')
                    }
                }
            }
        })
    }

    /**
     * Validate account numbers
     */
    if(values.detail.accountNumbers.length > 0)
    {
        values.detail.accountNumbers.map((key, index) => {

            if(key.IBAN == undefined || key.IBAN == '')
            {
                if(errors.detail.accountNumbers[index] == undefined)
                {
                    errors.detail.accountNumbers[index] = {
                        IBAN: _('requiredField')
                    }
                }
                else
                {
                    errors.detail.accountNumbers[index]['IBAN'] = _('requiredField')
                }
            }

            if(key.IBAN != undefined && key.IBAN.length > 20)
            {
                if(errors.detail.accountNumbers[index] == undefined)
                {
                    errors.detail.accountNumbers[index] = {
                        IBAN: _('maxLength20')
                    }
                }
                else
                {
                    errors.detail.accountNumbers[index]['IBAN'] = _('maxLength20')
                }
            }
        })
    }

    /**
     * Validate licences
     * Remove as Brecht requested
     */
    /**if(values.detail.licences.length > 0)
    {
        values.detail.licences.map((key, index) => {


            if(key.licenceDate == undefined || key.licenceDate == '')
            {
                if(errors.detail.licences[index] == undefined)
                {
                    errors.detail.licences[index] = {
                        licenceDate: _('requiredField')
                    }
                }
                else
                {
                    errors.detail.licences[index]['licenceDate'] = _('requiredField')
                }
            }
        })
    } **/

    /**
     * Validate contacts
     */
    if(values.detail.contacts.length > 0)
    {
        values.detail.contacts.map((key, index) => {
            if(key.contactLastName == '' || key.contactLastName == undefined)
            {
                if(errors.detail.contacts[index] == undefined)
                {
                    errors.detail.contacts[index] = {
                        contactLastName: _('requiredField')
                    }
                }
                else
                {
                    errors.detail.contacts[index]['contactLastName'] = _('requiredField')
                }
            }

            if(key.contactLastName != undefined && key.contactLastName.length > 50)
            {
                if(errors.detail.contacts[index] == undefined)
                {
                    errors.detail.contacts[index] = {
                        contactLastName: _('maxLength50')
                    }
                }
                else
                {
                    errors.detail.contacts[index]['contactLastName'] = _('maxLength50')
                }
            }

            if(key.contactFirstName != undefined && key.contactFirstName.length > 50)
            {
                if(errors.detail.contacts[index] == undefined)
                {
                    errors.detail.contacts[index] = {
                        contactFirstName: _('maxLength50')
                    }
                }
                else
                {
                    errors.detail.contacts[index]['contactFirstName'] = _('maxLength50')
                }
            }

            if(key.contactType == '' || key.contactType == undefined)
            {
                if(errors.detail.contacts[index] == undefined)
                {
                    errors.detail.contacts[index] = {
                        contactType: _('requiredField')
                    }
                }
                else
                {
                    errors.detail.contacts[index]['contactType'] = _('requiredField')
                }
            }
        })
    }


    return errors
}



/**
 * Create connect to get requested states and actions
 */
@connect(state => {
    // The current appLanguage
    const appLanguage = state.app.lang

    let errorReport = null

    // Get the general state data from the clientProfileForm state
    const { clientId, formStatus, selectedCheckboxes, type} = state.clientProfileForm
    let { clientData } = state.clientProfileForm

    // Generate options for client select lists
    const clientOptionsDict = generateClientDicts(state.client.clientOptionsDict, appLanguage)

    if(type == 'edit')
    {
        clientData = normalizeData(clientData, appLanguage, clientOptionsDict);

        if(clientData['detail'].birthCountry === "1"){
            clientData['detail'].birthZipCity =  `${clientData['detail'].birthPostalCode}&${clientData['detail'].birthLocality}`
        }

        //This because of issue BEWB-312 in order to detect error in production
        if (clientData.main.clientType === "2") {
            let legalFormHasCorrectValue = false,

            clientLegalForm = nesProp.get(clientData, "main.legalForm"),
            clientLegalFormId = nesProp.get(clientData, "main.legalFormId"),
            clientLanguage = nesProp.get(clientData, "detail.language")

            clientOptionsDict.legalForm.map((item) => {
                if (String(clientLegalForm).toUpperCase() == String(item.label).toUpperCase()) {
                    legalFormHasCorrectValue = true
                }
            })

            if (clientLegalForm && !legalFormHasCorrectValue) {
                const error = {
                    level: "debug",
                    moduleName: "clientProfile",
                    message: "Selection list not match for legalForm = " + clientLegalForm + " id = " + clientLegalFormId,
                    details: {
                        clientData,
                        clientLegalForm,
                        clientLegalFormId,
                        legalFormDict: clientOptionsDict.legalForm,
                        appLanguage,
                        clientLanguage,
                        browserError: true,
                        sendReport: true
                    },
                }
                errorReport = {
                    error,
                    version: process.env.VERSION
                }
            }
        }
    }

    if(type == 'create')
    {
        clientData['main'] = {
            clientType: "1",
            mainAddress: {
                country: "1"
            }
        }

        clientData['detail'] = {

            correspondanceAddress: {
                country: undefined
            },
            nationality: "1",
            language: "1",
        }
    }

    if(clientData && clientData.detail != undefined)
    {
        clientData.detail.accountNumbers && generateUUIdForLists(clientData.detail.accountNumbers)
        clientData.detail.licences && generateUUIdForLists(clientData.detail.licences)
        clientData.detail.emails && generateUUIdForLists(clientData.detail.emails)
        clientData.detail.phoneNumbers && generateUUIdForLists(clientData.detail.phoneNumbers)
        clientData.detail.contacts && generateUUIdForLists(clientData.detail.contacts)
    }

    return ({
        initialValues: clientData,
        subModule: state.clients.subModule,
        appLanguage: appLanguage,
        clientData,
        clientId,
        formStatus,
        selectedCheckboxes,
        formType: type,
        clientOptionsDict,
        setProfileFormCheckbox,
        cleanProfileFormCheckbox,
        data: state.clients.data,
        existingClients: state.clientProfileForm.existingClients,
        fetchExistingClients,
        setOpened, setClientSubModule, setB2bCompanyOpened, setB2bCompanySubModule,
        fetchExistingClient,
        changeListDefaultError,
        b2bCompanyCompany : state.b2bCompany.b2bCompanyCompany,
        modalStatus: state.clientProfileForm.clientModal,
        formErrors: state.clientProfileForm.formStatus,
        errorReport,
    })
})

/**
 * The redux form contains all the form fields what we require
 */
@reduxForm({
    form: "clientProfileEdit",
    fields: [
        'main.clientType',
        'main.legalForm',
        'main.legalFormId',
        'main.name',
        'main.firstName',
        'main.lastName',
        'main.clientNumber',
        'detail.gender',
        'detail.title',
        'detail.nationality',
        'detail.language',
        'detail.birthCountry',
        'detail.birthPostalCode',
        'detail.birthLocality',
        'detail.birthZipCity',
        'detail.maritalStatus',
        'detail.profession',
        'detail.activSector',
        'detail.socialStatus',
        'detail.taxStatus',
        'detail.ppp',
        'detail.nationalIdNumber',

        'detail.emails[]',
        'detail.emails[].email',
        'detail.emails[].default',
        'detail.emails[].uniqueId',

        'detail.licences[]',
        'detail.licences[].licenceCategory',
        'detail.licences[].licenceDate',
        'detail.licences[].uniqueId',

        'main.mainAddress.country',
        'main.mainAddress.extension',
        'main.mainAddress.locality',
        'main.mainAddress.number',
        'main.mainAddress.postalCode',
        'main.mainAddress.street',
        'main.mainAddress.zipCity',

        'main.dateOfBirth',
        'main.companyRegistrationNumber',

        'detail.phoneNumbers[]',
        'detail.phoneNumbers[].default',
        'detail.phoneNumbers[].mobile',
        'detail.phoneNumbers[].number',
        'detail.phoneNumbers[].uniqueId',

        'detail.accountNumbers[]',
        'detail.accountNumbers[].BIC',
        'detail.accountNumbers[].IBAN',
        'detail.accountNumbers[].uniqueId',

        'detail.contacts[]',
        'detail.contacts[].contactName',
        'detail.contacts[].contactFirstName',
        'detail.contacts[].contactLastName',
        'detail.contacts[].contactNumber',
        'detail.contacts[].contactType',
        'detail.contacts[].contactdateOfBirth',
        'detail.contacts[].contactgender',
        'detail.contacts[].uniqueId',

        'detail.correspondanceAddress.country',
        'detail.correspondanceAddress.extension',
        'detail.correspondanceAddress.locality',
        'detail.correspondanceAddress.number',
        'detail.correspondanceAddress.postalCode',
        'detail.correspondanceAddress.street',
        'detail.correspondanceAddress.zipCity',
    ],
    validate,
})

/**
 * Creates the edit profile component
 */
export default class ClientProfileForm extends Component
{
    static propTypes = {
        fields: React.PropTypes.object.isRequired,
        handleSubmit: React.PropTypes.func.isRequired,
        clientOptionsDict: React.PropTypes.array
    }

    constructor(props) {
        super(props)

        this.handleSubmit = this.handleSubmit.bind(this)
        this.zoomTo = this.zoomTo.bind(this)
        this.state = {
            modalIsOpen: false, 
            clientDictionary: [], 
            errorReportSent: false, 
            showProfessionFullList: false,
            showActivSectorFullList: false
        }
    }

    componentWillMount() {
        const { dispatch, clientOptionsDict } = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
            .then((dictionary) => {
                this.setClientOptionsDict(dictionary)
            })
        } else {
            if (!this.state.clientDictionary) {
                this.setClientOptionsDict(clientOptionsDict)
            }
        }

        dispatch(clientProfileFormSentToFalse())
    }

    onBirthCoutryChangeHandler(e) {
        const { dispatch, fields } = this.props
        const birthCountryInitialValues = fields.detail.birthCountry.initialValue
        const birthLocalityInitialValues = fields.detail.birthLocality.initialValue || ''
        const birthPostalCodeInitialValues = fields.detail.birthPostalCode.initialValue || ''
        const birthZipCityInitialValues = fields.detail.birthZipCity.initialValue

        if(e.value === birthCountryInitialValues){

            dispatch(change("clientProfileEdit", "detail.birthCountry", e.value))
            dispatch(change("clientProfileEdit", "detail.birthLocality", birthLocalityInitialValues))
            dispatch(change("clientProfileEdit", "detail.birthPostalCode", birthPostalCodeInitialValues))
            dispatch(change("clientProfileEdit", "detail.birthZipCity", birthZipCityInitialValues))
        }else{
            dispatch(change("clientProfileEdit", "detail.birthCountry", e.value))
            dispatch(change("clientProfileEdit", "detail.birthLocality", ''))
            dispatch(change("clientProfileEdit", "detail.birthPostalCode", ''))
            dispatch(change("clientProfileEdit", "detail.birthZipCity", ''))
        }
    }

    onBirthZipCityChangeHandler(e){
        const { dispatch } = this.props
        const split = e.value.split('&')
        dispatch(change("clientProfileEdit", "detail.birthPostalCode", split[0]))
        dispatch(change("clientProfileEdit", "detail.birthLocality", split[1]))
        dispatch(change("clientProfileEdit", "detail.birthZipCity", e.value))
    }
    /**
     * Set client options dict in to the state
     * @param {object} dictionary - contains the dictionary
     */
    setClientOptionsDict(dictionary) {
        const {appLanguage} = this.props
        this.setState({clientDictionary: generateClientDicts(dictionary, appLanguage)})
    }

    componentWillUnmount() {
        const { dispatch, cleanProfileFormCheckbox } = this.props
        // need to clean da form data to -- i think soo
        dispatch(cleanProfileFormCheckbox())
        dispatch(cleanClientProfileForm())
        dispatch(clientProfileFormSentToFalse())
    }

    componentDidMount() {
        const {dispatch, errorReport} = this.props
        const {errorReportSent} = this.state

        if (!errorReportSent &&  errorReport){
            dispatch(reportError(errorReport))
            .then(
                res =>{
                    this.setState({errorReportSent: true})
            })
            .catch(err => console.warn(err))
        }
    }

    /**
     * Trim whitespaces by walkin trought the hole object values.
     * @param {*} obj
     * @returns
     */
    trimWhitespaceForValueProps(obj, keyName = "") {
        // when we the object is a end of the object tree and the key is "value" (the form elements value prorp)
        // only on that caset to TRIM the string, in test we don't touch nothing.
        if (typeof obj === 'string' && keyName === 'value') {
            return obj.trim()
        } else if (typeof obj === 'object' && obj !== null) {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // go deeper
                    obj[key] = this.trimWhitespaceForValueProps(obj[key], key)
                }
            }
            return obj
        } else {
            return obj
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        const { dispatch, clientId, appLanguage, formType, invalid, fields, changeListDefaultError, b2bCompanyCompany } = this.props
        let isDefaultEmail = false
        let isSetDefaultPhone = false

        if (fields.detail.emails.length > 0) {
            fields.detail.emails.map((key, index) => {
                if(key.default.checked == true)
                {
                    isDefaultEmail = true
                }
            })
        } else {
            isDefaultEmail = true
        }

        if (fields.detail.phoneNumbers.length > 0) {
            fields.detail.phoneNumbers.map((onePhoneNumber, index) => {
                if (onePhoneNumber.default.checked == true) {
                    isSetDefaultPhone = true
                }
            })
        } else {
            isSetDefaultPhone = true
        }

        dispatch(changeListDefaultError('email', !isDefaultEmail))
        dispatch(changeListDefaultError('phone', !isSetDefaultPhone))

        let formData = JSON.parse(JSON.stringify(fields))

        // legalForm translate to ID for oracle call
        if (fields.main.clientType.value == 2) {
            formData.main.legalForm.value = formData.main.legalFormId ? formData.main.legalFormId.value : formData.main.legalForm.value

            if (formData && formData.main && formData.main.legalFormId) {
                delete formData.main.legalFormId
            }
        }

        if (invalid == true || isDefaultEmail == false || isSetDefaultPhone == false) {
            this.openNotificationModal()
            this.props.touchAll()
        } else {

            formData = this.trimWhitespaceForValueProps(formData)

            if (formType == 'edit') {
                dispatch(updateClientProfile(formData, clientId, b2bCompanyCompany && b2bCompanyCompany.companyId || null))
            } else {
                dispatch(createClientProfile(formData))
            }
         }
    }

    zoomTo(clientNumber) {
        const { dispatch, setOpened, setClientSubModule, setB2bCompanyOpened, setB2bCompanySubModule } = this.props

        dispatch(setOpened(clientNumber))
        dispatch(setClientSubModule('profile'))

        dispatch(setB2bCompanyOpened(clientNumber))
        dispatch(setB2bCompanySubModule('profile'))
    }

    loadClientData(clientId) {
        const { dispatch, fetchExistingClient } = this.props
        dispatch(fetchExistingClient(clientId))
    }

    handleFormChange(event) {
        const { dispatch, fetchExistingClients, fields: { main, detail} } = this.props

        let clientQuery = {
            name: '',
            street: '',
            postalCode: '',
            dateOfBirth: '',
            companyRegistrationNumber: '',
            email: '',
            phoneNumber: '',
        }

        let clientFirstName = ''
        let clientLastName = ''
        let streetAddress = ''
        let streetNumber = ''
        let streetBus = ''
        let postalCode = ''
        let dateOfBirth = ''
        let companyRegistrationNumber = ''
        let email = ''
        let phoneNumber = ''

        if (main.firstName && main.firstName.value && main.firstName.value != undefined) {
             clientFirstName = main.firstName.value
        }

        if (main.lastName && main.lastName.value && main.lastName.value != undefined) {
            clientLastName = main.lastName.value
        }

        if (main.mainAddress && main.mainAddress.street && main.mainAddress.street.value != undefined) {
            streetAddress = main.mainAddress.street
        }

        if (main.mainAddress && main.mainAddress.number && main.mainAddress.number.value != undefined) {
            streetNumber = main.mainAddress.number
        }

        if (main.mainAddress && main.mainAddress.extension && main.mainAddress.extension.value != undefined) {
            streetBus = main.mainAddress.extension
        }

        if (main.mainAddress && main.mainAddress.postalCode && main.mainAddress.postalCode.value != undefined) {
            postalCode = main.mainAddress.postalCode
        }

        if (main.dateOfBirth && main.dateOfBirth.value && main.dateOfBirth.value != undefined) {
            dateOfBirth = main.dateOfBirth.value
        }

        if (main.companyRegistrationNumber && main.companyRegistrationNumber.value && main.companyRegistrationNumber.value != undefined) {
            companyRegistrationNumber = main.companyRegistrationNumber.value
        }

        clientQuery['name']                         = clientLastName + ' ' + clientFirstName
        clientQuery['street']                       = streetAddress + ' ' + streetNumber + ' '  + streetBus
        clientQuery['postalCode']                   = postalCode
        clientQuery['dateOfBirth']                  = dateOfBirth
        clientQuery['companyRegistrationNumber']    = companyRegistrationNumber
        clientQuery['email']                        = email
        clientQuery['phoneNumber']                  = phoneNumber

        dispatch(fetchExistingClients(clientQuery))
    }

    makeOnBlur(field) {
        return (event) => {
            field.onChange(event);
            this.handleFormChange(event);
        };
    }

    openNotificationModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

    /**
     * This function will handle toggle between showing partial list and full list of options for
     * profession list when user clicks on show more option
     * @param {*} value 
     */
    toggleShowFullProfessionList = (value) => {
        if(value === 'see_more_results') {
            this.setState({showProfessionFullList: true})
        }else if(value === 'see_less_results') {
            this.setState({showProfessionFullList: false})
        }
    }

    /**
     * This function will handle toggle between showing partial list and full list of options for 
     * activ sector when user clicks on show more option
     * @param {*} value 
     */
    toggleShowFullActivSectorList(value) {
        if(value === 'see_more_results') {
            this.setState({showActivSectorFullList: true})
        }else if(value === 'see_less_results') {
            this.setState({showActivSectorFullList: false})
        }
    }

    /**
     * This functionality provides partial or full list for profession options
     * The partial list is hardcoded for it is provided in BEWB - 804 
     * @param {*} professionFullList 
     * @returns 
     */
    getProfessionOptionsList(professionFullList) {
        const {showProfessionFullList} = this.state

        // this a partial list provided by client in task BEWB-804
        const hardcodedMinimalList = ['2', '3', '8', '1', '10', '11', '12', '7', '26', '9', '37', '6', '41', '23', '15']
        if(!showProfessionFullList) {
            return professionFullList.filter(oneProfession => hardcodedMinimalList.some(e => e == oneProfession.value))
        }
        return professionFullList
    }

     /**
     * This functionality provides partial or full list for sectors options
     * The partial list is hardcoded for it is provided in BEWB - 804 
     * @param {*} activSectorFullList 
     * @returns 
     */
     getActivSectorOptionsList(activSectorFullList) {
        const {showActivSectorFullList} = this.state
        const hardcodedMinimalList = ['80', '85', '91', '129', '51', '114', '45', '65', '72', '55', '40', '70', '128', '76', '126', '127', '92', '119', '52', '109', '66']
        // this a partial list provided by client in task BEWB-804
        if(!showActivSectorFullList) {
            return activSectorFullList.filter(oneProfession => hardcodedMinimalList.some(e => e == oneProfession.value))
        }
        return activSectorFullList
    }

    /**
     * Implements the render function for the component
     * Renders the component form data
     */
    render() {
        const { fields: { main, detail }, selectedCheckboxes, dispatch, formStatus, setProfileFormCheckbox,
            data, formType, existingClients, modalStatus, clientId, setSubModule, formErrors, canCreateOnlyLegalClient, canModifyOnlyLegalClient } = this.props
        let { clientOptionsDict } = this.props
        const {modalIsOpen, clientDictionary, showProfessionFullList, showActivSectorFullList } = this.state
        if (clientDictionary != undefined && clientDictionary.length > 1) {
          clientOptionsDict = clientDictionary
        }

        let openModal = function(e) {
            e.preventDefault()
        }

        openModal = this.props.openModal

        const zoomTo = (clientNumber) => {
            this.zoomTo(clientNumber)
        }

        const loadClientData = (clientId) => {
            this.loadClientData(clientId)
        }

        let generalInformationColumns = []

        //if the form is type create, and the user has create rights only for legal client we need to force clientType to  "2" (Rechtspersoon)
        if(formType == 'create' && canCreateOnlyLegalClient && +main.clientType.value == 1) {
           dispatch(change('clientProfileEdit', 'main.clientType', '2'))
        }
        const professionOptions = this.getProfessionOptionsList(clientOptionsDict.profession)
        if(showProfessionFullList) {
            professionOptions.push({value: 'see_less_results', label: _('showLessResults')})
        }else {
            professionOptions.push({value: 'see_more_results', label: _('showMoreResults')})
        }

        const activSectorOptionsList = this.getActivSectorOptionsList( clientOptionsDict.activSector)
        if(showActivSectorFullList) {
            activSectorOptionsList.push({value: 'see_less_results', label: _('showLessResults')})
        }else {
            activSectorOptionsList.push({value: 'see_more_results', label: _('showMoreResults')})
        }

        /**
         * If the form type is create then print other form elements
         */
        if (formType == 'create') {
            if (main.clientType.value == 2) {
                generalInformationColumns = [
                    [
                        {label: _('clientType') + ' *', value: generateField(<SearchableSelectWrapper isDisabled={canCreateOnlyLegalClient} {...main.clientType} options={clientOptionsDict.personType} isSearchable/>, main.clientType)},
                        {label: _('lastName') + ' *', value: generateField(<Input type="text" {...main.lastName} onBlur={this.makeOnBlur(main.lastName)} />, main.lastName)},
                        {label: _('legalForm') + ' *', value:
                            generateField(
                                <SearchableSelectWrapper
                                    isSearchable
                                    onBlur={this.makeOnBlur(main.legalFormId)}
                                    {...main.legalFormId}
                                    options={clientOptionsDict.legalForm}
                                    onChange={(newValue) => {
                                        main.legalFormId.onChange(newValue.value)
                                        main.legalForm.onChange(newValue.label)
                                        main.legalFormId.value = newValue.value
                                        main.legalForm.value = newValue.label
                                        return newValue
                                    }}
                                />,
                                main.legalFormId
                            )
                        },
                        {label: _('nationality'), value: generateField(<SearchableSelectWrapper {...detail.nationality} options={clientOptionsDict.nationality} isSearchable/>, detail.nationality)},
                    ],
                    [
                        {label: _('language') + ' *', value: generateField(<SearchableSelectWrapper {...detail.language} options={clientOptionsDict.language} isSearchable />, detail.language)},
                        {label: _('companyRegistrationNumber'), value: generateField(<Input type="text" {...main.companyRegistrationNumber} onBlur={this.makeOnBlur(main.companyRegistrationNumber)}  />, main.companyRegistrationNumber)},
                        {label: _('activSector'), value: generateField(<SearchableSelectWrapper {...detail.activSector} options={clientOptionsDict.activSector} isSearchable />, detail.activSector)},
                        {label: _('taxStatus'), value: generateField(<SearchableSelectWrapper {...detail.taxStatus} options={clientOptionsDict.taxStatus} isSearchable />, detail.taxStatus)},
                    ]
                ]
            } else {
                generalInformationColumns = [
                    [
                        {label: _('clientType') + ' *', value: generateField(<SearchableSelectWrapper {...main.clientType} options={clientOptionsDict.personType} isSearchable/>, main.clientType)},
                        {label: _('lastName') + ' *', value: generateField(<Input type="text" {...main.lastName} onBlur={this.makeOnBlur(main.lastName)} />, main.lastName)},
                        {label: _('firstName') + ' *', value: generateField(<Input type="text" {...main.firstName} onBlur={this.makeOnBlur(main.firstName)} />, main.firstName)},
                        {label: _('gender') + ' *', value: generateField(<SearchableSelectWrapper {...detail.gender} options={clientOptionsDict.gender} isSearchable />, detail.gender)},
                        {label: _('nationalIdNumber'), value: generateField(<Input type="text" {...detail.nationalIdNumber} onBlur={this.makeOnBlur(detail.nationalIdNumber)} />, detail.nationalIdNumber)},
                        {label: _('nationality') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.nationality} options={clientOptionsDict.nationality} isSearchable />, detail.nationality)},
                        {label: _('language') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.language} options={clientOptionsDict.language} isSearchable />, detail.language)},
                        {label: _('ppp') , value: generateField(<SearchableSelectWrapper {...detail.ppp} options={clientOptionsDict.ppp} isSearchable />, detail.ppp)},
                    ],
                    [
                        {label: _('dateOfBirth'), value: generateField(<DatePicker {...main.dateOfBirth} onBlur={this.makeOnBlur(main.dateOfBirth)} />, main.dateOfBirth)},
                        {label: _('birthCountry'), value: generateField(<SearchableSelectWrapper {...detail.birthCountry} options={clientOptionsDict.birthCountry} isSearchable />, detail.birthCountry)},
                        {label: _('maritalStatus'), value:generateField(<SearchableSelectWrapper {...detail.maritalStatus} options={clientOptionsDict.maritalStatus} isSearchable />, detail.maritalStatus)},
                        {label: _('clientTitle') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.title} options={clientOptionsDict.title} isSearchable />, detail.title)},
                        {label: _('companyRegistrationNumber'), value: generateField(<Input type="text" {...main.companyRegistrationNumber} onBlur={this.makeOnBlur(main.companyRegistrationNumber)}  />, main.companyRegistrationNumber)},
                        {label: _('profession'), value: generateField(<SearchableDynamicListSelectWrapper {...detail.profession} toggleShowFullList={this.toggleShowFullProfessionList.bind(this)} options={professionOptions} isSearchable />, detail.profession)},
                        {label: _('activSector'), value: generateField(<SearchableDynamicListSelectWrapper {...detail.activSector} toggleShowFullList={this.toggleShowFullActivSectorList.bind(this)} options={activSectorOptionsList} isSearchable />, detail.activSector)},
                        {label: _('socialStatus'), value: generateField(<SearchableSelectWrapper {...detail.socialStatus} options={clientOptionsDict.socialStatus} isSearchable />, detail.socialStatus)},
                        {label: _('taxStatus'), value: generateField(<SearchableSelectWrapper {...detail.taxStatus} options={clientOptionsDict.taxStatus} isSearchable />, detail.taxStatus)},
                    ]
                ]
            }
        } else {
            if (main.clientType.value == 2) {
                generalInformationColumns = [
                    [
                        {label: _('legalForm') + ' *', value: generateField(
                            <SearchableSelectWrapper
                                {...main.legalFormId}
                                options={clientOptionsDict.legalForm}
                                onChange={(newValue) => {
                                    main.legalFormId.onChange(newValue.value)
                                    main.legalForm.onChange(newValue.label)
                                    main.legalFormId.value = newValue.value
                                    main.legalForm.value = newValue.label
                                }}
                            />,
                            main.legalFormId
                            )
                        },
                        {label: _('nationality'), value: generateField(<SearchableSelectWrapper  {...detail.nationality} options={clientOptionsDict.nationality} isSearchable />, detail.nationality)},
                        {label: _('language') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.language} options={clientOptionsDict.language} isSearchable />, detail.language)},
                    ],
                    [
                        {label: _('companyRegistrationNumber'), value: generateField(<Input type="text" {...main.companyRegistrationNumber} searchable={true} />, main.companyRegistrationNumber)},
                        {label: _('activSector'), value: generateField(<SearchableSelectWrapper {...detail.activSector} options={clientOptionsDict.activSector} isSearchable />, detail.activSector)},
                        {label: _('taxStatus'), value: generateField(<SearchableSelectWrapper {...detail.taxStatus} options={clientOptionsDict.taxStatus} isSearchable />, detail.taxStatus)},
                    ]
                ]
            } else {
                generalInformationColumns = [
                    [
                        {label: _('gender') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.gender} options={clientOptionsDict.gender}  isSearchable />, detail.gender)},
                        {label: _('clientTitle') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.title} options={clientOptionsDict.title} isSearchable />, detail.title)},
                        {label: _('nationalIdNumber'), value: generateField(<Input type="text" {...detail.nationalIdNumber} onBlur={this.makeOnBlur(detail.nationalIdNumber)} />, detail.nationalIdNumber)},
                        {label: _('nationality') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.nationality} options={clientOptionsDict.nationality} isSearchable />, detail.nationality)},
                        {label: _('language') + ' *', value: generateField(<SearchableSelectWrapper  {...detail.language} options={clientOptionsDict.language} isSearchable />, detail.language)},
                        {label: _('ppp') , value: generateField(<SearchableSelectWrapper {...detail.ppp} options={clientOptionsDict.ppp} isSearchable />, detail.ppp)},
                    ],
                    [
                        {label: _('dateOfBirth'), value: generateField(<DatePicker {...main.dateOfBirth} />, main.dateOfBirth)},
                        {label: _('birthCountry'), value: generateField(<SearchableSelectWrapper {...detail.birthCountry} options={clientOptionsDict.birthCountry} isSearchable onChange={e=>this.onBirthCoutryChangeHandler(e)} />, detail.birthCountry)},
                        {label: _('maritalStatus'), value:generateField(<SearchableSelectWrapper {...detail.maritalStatus} options={clientOptionsDict.maritalStatus} isSearchable />, detail.maritalStatus)},
                        {label: _('companyRegistrationNumber'), value: generateField(<Input type="text" {...main.companyRegistrationNumber} />, main.companyRegistrationNumber)},
                        {label: _('profession'), value: generateField(<SearchableDynamicListSelectWrapper {...detail.profession} toggleShowFullList={this.toggleShowFullProfessionList.bind(this)} options={professionOptions} isSearchable />, detail.profession)},
                        {label: _('activSector'), value: generateField(<SearchableDynamicListSelectWrapper {...detail.activSector} toggleShowFullList={this.toggleShowFullActivSectorList.bind(this)} options={activSectorOptionsList} isSearchable />, detail.activSector)},
                        {label: _('socialStatus'), value: generateField(<SearchableSelectWrapper {...detail.socialStatus} options={clientOptionsDict.socialStatus} isSearchable />, detail.socialStatus)},
                        {label: _('taxStatus'), value: generateField(<SearchableSelectWrapper {...detail.taxStatus} options={clientOptionsDict.taxStatus} isSearchable />, detail.taxStatus)},
                    ]
                ]
            }
        }

        if(main.clientType.value == 1 && detail.birthCountry.value && detail.birthCountry.value === '1'){

            generalInformationColumns = [...generalInformationColumns]
            generalInformationColumns[1].splice (1, 1, ...[
                {label: _('birthCountry'), value: generateField(
                    <div>
                        <SearchableSelectWrapper style={{marginBottom: '10px'}} {...detail.birthCountry} options={clientOptionsDict.birthCountry} isSearchable onChange={e=>this.onBirthCoutryChangeHandler(e)} />
                        <label> {_('birthPlaceCodeAndLocality')} * </label>
                        <SearchableSelectWrapper {...detail.birthZipCity} options={clientOptionsDict.birthLocality} isSearchable onChange={e=>this.onBirthZipCityChangeHandler(e)} />
                    </div>,
                    detail.birthCountry
                )},
            ])

        }else if (main.clientType.value == 1 && detail.birthCountry.value && detail.birthCountry.value !== '1')
        {
            generalInformationColumns = [...generalInformationColumns]
            generalInformationColumns[1].splice (1, 1, ...[
                {label: _('birthCountry'), value: generateField(
                    <div>
                        <SearchableSelectWrapper style={{marginBottom: '10px'}} {...detail.birthCountry} options={clientOptionsDict.birthCountry} isSearchable onChange={e=>this.onBirthCoutryChangeHandler(e)} />
                        <label>{_('birthPostalCode')} </label>
                        <Input style={{marginBottom: '10px'}} type="text" {...detail.birthPostalCode} onBlur={this.makeOnBlur(detail.birthPostalCode)} />
                        <label>{_('birthLocality')} </label>
                        <Input type="text" {...detail.birthLocality} onBlur={this.makeOnBlur(detail.birthLocality)} />
                    </div>,
                    detail.birthCountry
                )},
            ])
        }

        const generalExtended = [
            [
                {label: _('ibans'), value: generateField(<IbansListSelect data={detail.accountNumbers} />, detail.accountNumbers)},
            ],
            [
                {label: _('licenses'), value: generateField(<LicensesListSelect data={detail.licences} selectCategoryOptions={clientOptionsDict.licenceCategory} />, detail.licences)},
            ]
        ]

        const addressColumns = [
            [
                {noLabel: true, value: generateField(<ClientAddressList data={main.mainAddress} countryOptions={clientOptionsDict.country} title={_('mainAddress')} addType="mainaddress" dispatch={dispatch} />, main.mainAddress)},
            ],
            [
                {noLabel: true, value: generateField(<ClientAddressList data={detail.correspondanceAddress} countryOptions={clientOptionsDict.country} title={_('correspondanceAddress')} addType="corressadd" dispatch={dispatch} />, detail.correspondanceAddress)},
            ]
        ]

        const contactColumns = [
            [
                {label: _('emails'), value: generateField(<EmailListSelect dispatch={dispatch} data={detail.emails} formStatus={formStatus} />, detail.emails)},
                {label: _('relation'), value: generateField(<RelationListSelect data={detail.contacts} setProfileFormCheckbox={setProfileFormCheckbox} dispatch={dispatch} selectedCheckboxes={selectedCheckboxes} relationOptions={clientOptionsDict.relationType} genderOptions={clientOptionsDict.gender} officeClients={existingClients} />, detail.contacts)},
            ],
            [
                {label: _('phoneNumbers'), value: generateField(<PhoneListSelect dispatch={dispatch} data={detail.phoneNumbers} formStatus={formStatus}/>, detail.phoneNumbers)},
            ]
        ]

        return (
            <div>
                <form onSubmit={this.handleSubmit} className={styles.clientProfileForm}>
                    {formType == 'create' && <div className={styles.mainTitleDiv}>
                        <div className={styles.mainTitleContainer}>
                            <h2 className={styles.mainTitle}>{_('createClient')}</h2>
                        </div>
                    </div>}
                    <h3 className={styles.informationTitle}>{_('generalInformation')}</h3>
                    <KeyValue array={generalInformationColumns} customClass={styles.KeyValue}/>
                    <KeyValue array={generalExtended} customClass={styles.KeyValue} divider/>
                    <div className={styles.clientProfileResultsWrapper}>{formType == 'create' && <ClientProfileFormResults data={existingClients} zoomTo={zoomTo} loadClientData={loadClientData} />}</div>
                    <h3 className={styles.informationTitleBorder}>{_('addressInformation')}</h3>
                    <KeyValue array={addressColumns} customClass={styles.AddressKeyValue} divider/>
                    <h3 className={styles.informationTitleBorder}>{_('contactInformation')}</h3>
                    <KeyValue array={contactColumns} customClass={styles.KeyValue} divider/>

                    {formErrors.sent == true  && formErrors.problem != null &&
                        <div className={styles.formError}>
                            <p><strong>{_('createClientError')}</strong></p>
                            <p>{_('createClientRefError')}</p>
                            {formErrors.problem}
                        </div>
                    }


                    <div className={styles.buttons}>
                        {formType == 'create' &&
                            <button
                                className={`${styles.cancel}`}
                                type="submit"
                                onClick={e => openModal(e)}
                            >
                                {_('cancel')}
                            </button>
                        }

                        {formType == 'edit' &&
                            <button
                                className={`${styles.cancel}`}
                                type="submit"
                                onClick={(e) => {
                                        e.preventDefault()
                                        if(modalStatus)
                                        {
                                            openModal(e)
                                        }

                                        if(!modalStatus)
                                        {
                                            setSubModule('profile')
                                        }
                                }}
                            >
                                {_('cancel')}
                            </button>
                        }

                        <button
                            className={`${styles.next} + ${styles.enabled}`}
                            disabled={formStatus.isSending}
                            type="submit"
                        >
                            {_('save')}
                        </button>
                    </div>
                </form>

                 <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    <div className={styles.verifyModalContent}>
                        <span className={styles.title}>{_("requiredFieldsWarningTitle")}</span>
                        <p className={styles.message}>{_("requiredFieldsWarningMessage")}</p>
                        <div className={styles.verifyModalButtons}>
                            <input
                                onClick={() => this.openNotificationModal()}
                                type="button"
                                className={styles.greyButton + " enabled"}
                                value={_("requriedFieldsButtonText")}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientProfileForm.jsx